export default __webpack_public_path__ + "static/media/ic_avalanche_24.f6248905.svg";